/**
 * @fileoverview Display labels for workflow offset units (MOR-836).
 *
 * Kept outside the component files so fast refresh keeps working, and so
 * the item card and the flow view render identical badge text.
 */

import type { OffsetUnit } from "./WorkflowItemCard";

/** Compact "Day 14" / "14 bus. days" / "3 months" / "QE+28" badge text. */
export function offsetBadgeText(
  amount: number,
  unit: OffsetUnit | null,
): string {
  switch (unit) {
    case "business_days":
      return `${amount} bus. day${Math.abs(amount) === 1 ? "" : "s"}`;
    case "months":
      return `${amount} month${Math.abs(amount) === 1 ? "" : "s"}`;
    case "quarter_end":
      return amount === 0
        ? "Quarter end"
        : `QE${amount > 0 ? "+" : ""}${amount}`;
    default:
      return `Day ${amount}`;
  }
}
